import React from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { array, object, string } from "yup";
import { showToast } from "src/utils/showToaster";
import BlogForm from "../Layouts/BlogForm";
import { BlogFormValues } from "src/models/Blog.model";
import { useAddBlogMutation } from "src/services/BlogService";

type Props = {
  onClose: () => void;
};

const AddBlogWrapper = ({ onClose }: Props) => {
  // Form Initial Values
  const initialValues: BlogFormValues = {
    title: "",
    description: "",
    image: "",
    tags: [],
  };

  // Validation Schema
  const validationSchema = object().shape({
    title: string().required("Please enter title"),
    description: string().required("Please enter description"),
    tags: array()
      .of(string().trim().min(1, "Tag cannot be empty")) // each tag must be valid
      .min(1, "Please add at least one tag") // must have at least 1
      .required("Please add at least one tag"), // ✅ ensures it's not null/undefined
  });

  const [addBlog] = useAddBlogMutation();

  // Handle Submit
  const handleSubmit = (
    values: BlogFormValues,
    { setSubmitting, resetForm }: FormikHelpers<BlogFormValues>
  ) => {
    const payload = {
      title: values.title,
      image: values.image,
      description: values.description,
      tags: values.tags,
    };
    addBlog(payload).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          resetForm();
          onClose();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Dialog open maxWidth="lg" fullWidth>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            <BlogForm
              formikProps={formikProps}
              onClose={onClose}
              formType="ADD"
            />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default AddBlogWrapper;
